export const version = "bignumber/5.0.13";
//# sourceMappingURL=_version.js.map